import { Container } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import React, { FC } from "react";
import styled from "styled-components";
import { colors } from "../../utils/colors";

export const RawSeparator = styled.div`
    width: "100%";
    border-bottom: 1px solid ${transparentize(0.9, colors.brandDark)};
`;

export const Separator: FC<{ excludeSectionPadding?: boolean; className?: string }> = props => {
    const sep = <RawSeparator />;

    if (props.excludeSectionPadding) {
        return sep;
    }

    return (
        <div style={{ backgroundColor: "white" }}>
            <Container>{sep}</Container>
        </div>
    );
};
